import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-900 text-white">
                <Leaf size={20} className="text-emerald-400" />
              </span>
              <span className="font-display text-xl font-extrabold text-emerald-900">Çöpcepte</span>
            </div>
            <p className="mt-3 text-sm text-slate-600">Toplu al, değer kat.</p>
            <p className="mt-1 text-sm text-slate-500">Birinin fazlası, diğerinin ihtiyacı.</p>
          </div>
          <FooterCol title="Keşfet" links={[
            ["Tüm İlanlar", "/ilanlar"],
            ["Kategoriler", "/kategoriler"],
            ["Toptan Fırsatlar", "/toptan-firsatlar"],
            ["Tarlada Kalanlar", "/tarlada-kalanlar"],
          ]} />
          <FooterCol title="Satıcılar" links={[
            ["İlan Ver", "/panel/yeni-ilan"],
            ["Kurumsal Satıcılar", "/kurumsal-saticilar"],
            ["Alım Talepleri", "/alim-talepleri"],
          ]} />
          <FooterCol title="Hesap" links={[
            ["Giriş Yap", "/giris"],
            ["Üye Ol", "/kayit"],
            ["Panelim", "/panel"],
          ]} />
        </div>
        <div className="mt-10 border-t border-slate-200 pt-6 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} Çöpcepte. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="text-sm font-bold text-slate-900">{title}</h4>
      <ul className="mt-3 space-y-2">
        {links.map(([label, to]) => (
          <li key={to}>
            <Link to={to} className="text-sm text-slate-600 transition-colors hover:text-emerald-700">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
